module.exports = __webpack_public_path__ + "static/media/Cats eyes 08_FRANSKA-mixdown.af359d5a.mp3";